const _nav = {
  items: [
    {
      key: 1,
      name: '- v 2.5.2 -',
    //  url: '/gic-web/dashboard',
      url: '/gic-web/dashoneder',
    },
    {
      key: 2,
      name: 'Dashboard',
      icon: 'icon-puzzle',
      url: '/gic-web/dashone',
    },
    {
      key: 3,
      name: 'Svom Alerts',
      icon: 'icon-puzzle',
      url: '/gic-web/statussvom',
    },
 /*      {
      key: 3,
      name: 'Weather',
      icon: 'icon-puzzle',
      url: 'statusweather',
    }, */
    {
      key: 5,
      name: 'Performance',
      icon: 'icon-puzzle',
      url: 'performance', 
    },


/*          {
      key: 6,
      name: 'Sensors',
      icon: 'icon-puzzle',
      url: 'ViewSensorSubystem',
    },  */
/*     {
      key: 7,
      name: 'Multi Sensors',
      icon: 'icon-puzzle',
      url: 'ParamMultiSensor',
    },  */

    {
      key: 8,
      name: 'Calibration',
      icon: 'icon-puzzle',
      url: 'calibration',
    },

    {
      key: 4,
      name: 'Shifts',
      icon: 'icon-puzzle',
      url: '/gic-web/shifts',
    }, 

    {
      key: 9,
      name: 'Planning Observation',
      icon: 'icon-puzzle',
     url :'construction',
    },
    {
      key: 10,
      name: 'Observation Management',
      icon: 'icon-puzzle',
      url :'construction',
    },
/*     {
      key: 11,
      name: 'Liste Sensors',
      icon: 'icon-puzzle',
      url: '/gic-web/ListSensor',
    }, */
    {
      key: 11,
      name: 'Monitoring',
      icon: 'icon-puzzle',
      url: '/gic-web/monitoring',
    },
        {
      name: 'DECONNEXION',
      url: '/gic-web/logout',
      icon: 'icon-speedometer',
    },
    {
      name: 'Administrateur',
      url: '/gic-web/Administrateur',
      icon: 'icon-puzzle',
    },
  ]
};

export default _nav
